<template>
    <datepicker name="from" ref="fromDate"
                :placeholder="placeholder"
                :language="language"
                :monday-first="true"
                :format="format"
                :disabled="disabled"
                v-model="inputValue"
                :disabled-picker="disabledPicker"
                :calendar-button="true"
                clear-button-icon="glyphicon glyphicon-remove"
                calendar-button-icon="glyphicon glyphicon-time"
                @input="onInput"
    ></datepicker>
</template>

<script>
    import lang from '../services/lang';
    import Datepicker from 'vuejs-datepicker'

    const moment = require('moment');

    export default
    {
        components: {Datepicker},
        props: {
            'value': {},
            'format': {default: 'dd.MM.yyyy'},
            'outputFormat': {default: 'yyyy-MM-dd'}
        },
        data() {
            return {
                inputValue: this.value,
                inputFormat: null,
                placeholder: this.$translate.text('Day'),
                language: lang.current(),
                disabled: {
                    type: Object,
                    default() {
                        return null;
                    },
                },
                hightlighted: {
                    type: Object,
                    default() {
                        return {
                            dates: []
                        }
                    }
                },
                disabledPicker: false,

            }
        },
        methods:
        {
            onInput(value) {
                this.$emit('input', this.out(value));
            },
            out(value)
            {
                if (this.inputFormat) {
                    return moment(value).format(this.inputFormat);
                }
                
                return moment(value).format(this.outputFormat);
            }
        },
        watch: {
            value(_value)
            {
                if (_value)
                {
                    this.inputFormat = moment(_value).creationData().format;
                    this.inputValue = _value;

                    this.$emit('initialized', this.out(_value));
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Datepicker.vue?cf76a5ac